<template>
  <div class="jsqlx">
    <div class="calc-templete">
      <h6>建设期利息计算</h6>
      <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit">
        <t-row style="height: auto;align-items: stretch;">
          <t-col :span="6"
            style="border-right: 1px solid #DADDE1;padding-left: 40px;padding-right: 140px;padding-bottom: 50px;height: auto;">
            <div class="left-top-title"><span>建设期利息</span></div>
            <t-form-item label="计算依据">
              <a class="file-name" v-if="fileList" @click="fileOpenDialog(fileList.url)">{{ fileList.fileName }}</a>
              <a v-else class="no-file-name">无文件</a>
              <!-- <t-input v-model="formData.projectName" placeholder="请输入工程名称" ></t-input> -->
            </t-form-item>
            <t-form-item label="工程名称" name="projectName">
              <t-input v-model="formData.projectName" placeholder="请输入工程名称"></t-input>
            </t-form-item>

            <t-form-item label="贷款比例" name="ratioLoans">
              <t-input-number v-model="ratioLoans" placeholder="请输入贷款比例" suffix="%" type="number" :min="0" theme="normal"></t-input-number>
            </t-form-item>

            <t-form-item label="贷款利率" name="loanRate">
              <t-input-number v-model="loanRate" placeholder="请输入贷款利率" suffix="%" type="number" :min="0" theme="normal"></t-input-number>
            </t-form-item>

            <t-form-item label="投资总额" name="money">
              <t-input-number v-model="formData.money" placeholder="请输入投资总额" suffix="万元" type="number" :min="0" theme="normal"></t-input-number>
            </t-form-item>

            <t-form-item label="贷款时长" name="lengthLoan">
              <t-input-number v-model="formData.lengthLoan" placeholder="请输入贷款时长" suffix="年" type="number" :min="0" theme="normal"></t-input-number>
              <t-popup placement="right" showArrow>
                <template #content>
                  <div>不包含最后一年的整数年份</div>
                </template>
                <t-button theme="default" variant="outline" class="coefficient">查看说明

                </t-button>
              </t-popup>
            </t-form-item>

            <t-form-item label="建设期最后一年" name="lastYear">
              <t-input-number v-model="formData.lastYear" placeholder="请输入建设期最后一年" suffix="月" type="number" :min="0" theme="normal"></t-input-number>
              <t-popup placement="right" showArrow>
                <template #content>
                  <div>最后一年不满一年的具体月数</div>
                </template>
                <t-button theme="default" variant="outline" class="coefficient">查看说明

                </t-button>
              </t-popup>
            </t-form-item>

            <t-form-item name="modeRepayment" label="还款方式" class="form-item-left">
              <t-select v-model="formData.modeRepayment" placeholder="请选择还款方式">
                <t-option value="0" label="等额本息" key="等额本息" />
                <t-option value="1" label="等额本金" key="等额本金" />
              </t-select>
              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible1">系数说明
                <img src="@/assets/icon/Vector.svg"
                  style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>

            <t-form-item label="浮动幅度" name="floatingRange">
              <t-input-number v-model="floatingRange" placeholder="" suffix="%" :min="0" :max="100"
                theme="normal"></t-input-number>
            </t-form-item>
            <t-button theme="primary" type="submit" class="submit">点击计算（消耗2积分）</t-button>
          </t-col>
          <t-col :span="6" style="padding-left: 106px;padding-right: 70px;padding-bottom: 50px;">
            <div class="right-top-title"><span>计算结果</span></div>
            <t-form-item label="贷款总额" name="totalLoan">
              <t-input v-model="formData.totalLoan" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="还款总额" name="totalRepayments">
              <t-input v-model="formData.totalRepayments" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="利息总合" name="totalInterest">
              <t-input v-model="formData.totalInterest" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="年均还款" name="annualRepayment">
              <t-input v-model="formData.annualRepayment" placeholder="" disabled suffix="元"></t-input>
              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible2"
                v-if="formData.modeRepayment != 0">详细说明
                <img src="@/assets/icon/Vector.svg"
                  style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>
            <t-form-item label="计算过程">
              <t-textarea v-model="jsgc" placeholder="" disabled :autosize="{ minRows: 3, maxRows: 5 }"></t-textarea>
            </t-form-item>
            <t-button class="download" @click="downLoadWord" :disabled="!formData.annualRepayment"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button>
          </t-col>
        </t-row>





      </t-form>

    </div>
    <div class="calc-rules">
      <t-row>
        <t-col :span="6" style="border-right: 1px solid #DADDE1;">
          <h4><span>计算范围和计算公式</span></h4>
        </t-col>
        <t-col :span="6">
          <h4><span>费率标准</span></h4>
        </t-col>
      </t-row>
      <div class="calc-rules-value">
         <t-row style="height: auto; align-items: stretch;">
          <t-col :span="6" style="border-right: 1px solid #DADDE1;">
            <div class="calc-rules-value-left">
              <div class="title"><span>计算范围</span></div>
              <div class="info">{{ calculateRange }}</div>
              <div class="title" style="margin-top: 33px;"><span>计算公式</span></div>
              <div class="info" style="white-space: pre-line;">{{ calculationFormula }}</div>
            </div>
          </t-col>
          <t-col :span="6" style="padding: 20px;overflow: auto;" class='rate-table'>
            <div class="calc-rules-value-right">
              <t-table bordered row-key="index" :data="data" :columns="columns" />
            </div>
          </t-col>
        </t-row>
      </div>
    </div>

    <t-dialog placement="center" :visible="visible1" :footer="false" :onConfirm="close1" :onClose="close1"
      class="dialog1">
      <span slot="header">
        复杂程度调整系数
        <div class="closeButton" @click="close1"></div>
      </span>

      <t-row style="padding: 10px;">
        <t-col :span="12">
          <div style="text-align: left;">
            等额本息:
            <span
              style="float: right;text-align:left;line-height:30px">把按揭贷款的本金总额与利息总额相加，然后平均分摊到还款期限的每个月中。作为还款人，每个月还给银行固定金额，但每月还款额中的本金比重逐月递增、利息比重逐月递减。</span>
          </div>
        </t-col>
        <t-col :span="12">
          <div style="text-align: left;">
            等额本金:
            <span
              style="float: right;text-align:left;line-height:30px">将本金分摊到每个月内,同时付清上一交易日至本次还款日之间的利息。这种还款方式相对等额本息而言,总的利息支出较低,但是前期支付的本金和利息较多,还款负担逐月递减。</span>
          </div>
        </t-col>
      </t-row>

    </t-dialog>

    <t-dialog placement="center" :visible="visible2" :footer="false" :onConfirm="close2" :onClose="close2"
      class="dialog2">
      <t-table :max-height="300" :fixedRows="undefined" row-key="index" :data="repayments"
        :columns="repaymentscolumns" />
    </t-dialog>
    <!-- <help v-bind:visible.sync="helpOpen"></help> -->
    <file-view v-bind:visible.sync="visible" :fileUrl="openFileUrl" :downFileUrl="downFileUrl"></file-view>
  </div>
</template>

<script>
import { getjsqlx } from '@/api/data'
import { listFile } from "@/api/file";
import { listRate } from "@/api/rate";
// import Help from '@/components/Help.vue'

export default {
  name: 'jsqlxFee',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    // Help
  },
  data() {
    return {
      jsgc: null,
      visible: false,
      downFileUrl: null,
      openFileUrl: null,
      downLoading: false,
      validateMessage: {
        projectName: [
          {
            type: 'error',
            message: '项目名称不能为空',
          },
        ],
        money: [
          {
            type: 'error',
            message: '请输入规范数字',
          },
        ]

      },
      rules: {
        projectName: [{ required: true }, { type: 'warning' }],
        money: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
        lengthLoan: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
        lastYear: [{ required: true }, { pattern: /^(1[0-2]|[1-9])$/, message: '请输入规范月份', required: true, type: 'warning' }],
        modeRepayment: [{ required: true }, { type: 'warning' }],
      },
      helpOpen: false,
      floatingRange: null,
      ratioLoans: null,
      loanRate: null,
      downData: {},//下载时传值
      rateList: [],
      modeRepayment: null,
      visible1: false,
      visible2: false,
      formData: {
        ificationId: this.$route.query.ification,
        projectName: '',
        ratioLoans: null,//贷款比例
        loanRate: null,//贷款利率
        money: null,//投资总额
        lengthLoan: null,//贷款时长
        lastYear: null,//建设期最后一年
        modeRepayment: null,//还款方式（0：等额本息1：等额本金）
        floatingRange: null,//浮动幅度
        totalLoan: null,//贷款总额
        totalRepayments: null,//还款总额
        totalInterest: null,//利息总合
        annualRepayment: null,//年均还款
        monthlyPaymentLoan: null,//每期还款
        subtotal: null,
        result: null
      },
      fileList: [],
      repayments: [],
      data: [{

      }],
      repaymentscolumns: [
        {
          title: '还款期数',
          colKey: 'installment',
          width: 90,
        },
        {
          title: '每月本金',
          colKey: 'principal',
          width: 90,
        },
        {
          title: '每月利息',
          colKey: 'interest',
          width: 90,
        },
        {
          title: '累计已还本金',
          colKey: 'accumulatedPrincipal',
          width: 100,
        },
        {
          title: '月利率',
          colKey: 'monthlyRate',
          width: 90,
        },
        {
          title: '月应还本付息金额',
          colKey: 'totalPayment',
          width: 120,
        }
      ],
      columns: [
        {
          title: '序',
          colKey: 'id',
          width: 90,
        },
        {
          title: '收费区间值（万元）',
          width: 100,
          colKey: '-',
          children: [
            {
              colKey: 'startValue',
              title: '起值',
              width: 100,
            },
            {
              title: '终止',
              colKey: 'finalValue',
              width: 100,
            }
          ],
        },
        {
          title: '费率',
          colKey: 'rate',
          width: 100,
        }
      ],
      calculateRange: null,//计算范围
      calculationFormula: null // 计算公式


    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      listFile({ classificationId: this.$route.query.ification }).then(response => {
        // console.log(response)
        this.fileList = response.rows[0];

      });
      listRate({ ificationId: this.$route.query.ification }).then(res => {
        let i = 1
        res.rows.forEach((item) => {
          item.id = i++
          if (item.finalValue > 99999999) {
            item.finalValue = ""
          }
          this.data.push(item)
        })
        this.data = res.rows
      });
      this.getClassification(this.$route.query.ification || 3).then(res => {
        if (res.data.scope) {
          if (res.data.scope.indexOf("\\n") != -1) {
            this.calculateRange = res.data.scope.replaceAll('\\n', '\n')
          } else {
            this.calculateRange = res.data.scope
          }

        } else {
          this.calculateRange = '暂无数据'
        }
        if (res.data.particulars) {
          if (res.data.particulars.indexOf("\\n") != -1) {
            this.calculationFormula = res.data.particulars.replaceAll('\\n', '\n')
          } else {
            this.calculationFormula = res.data.particulars
          }
        } else {
          this.calculationFormula = '暂无数据'
        }
      })
    },
    onReset() {
      this.$message.success('重置成功');
      console.log('formData', this.formData);
    },
    onSubmit({ validateResult, firstError }) {
      if (validateResult === true) {
        if(this.ratioLoans == null) {
          this.$message.warning('请输入贷款比例');
          return;
        }
        if(this.loanRate == null) {
          this.$message.warning('请输入贷款利率');
          return;
        }

        this.submit()
        this.$message.success('提交成功');
      } else {
        console.log('Errors: ', validateResult);
        this.$message.warning(firstError);
      }
    },
    downLoadWord() {
      this.downLoading = true;
      let wordParam = {
        xmmc: this.formData.projectName,
        xsz: '投资总额:' + this.formData.money + `(万元);贷款比例:${this.ratioLoans}%;贷款利率:${this.loanRate}%;贷款时长:${this.formData.lengthLoan}年;建设期最后一年:${this.formData.lastYear}月;还款方式:${{0:'等额本息',1:'等额本金'}[this.formData.modeRepayment]};浮动幅度:${this.floatingRange}%。`,
        yjwj: this.fileList ? this.fileList.fileName.split('.')[0] : '--',

        jdlx: {0:'等额本息',1:'等额本金'}[this.formData.modeRepayment],
        tzze: this.formData.money + '万',
        hdlv: this.loanRate + '%',
        fdxs: this.floatingRange + '%',


        jsgc: this.jsgc,
        fulx: '建设期利息',
        zhj: this.formData.totalInterest,
      }
      this.download('/project/jsqlx/word', { id: this.downData.id, classId: 53, ...wordParam }
        , `建设期利息费.docx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    handleClear() {
      this.helpOpen = true
    },
    submit() {
      this.formData.ratioLoans = Number(this.ratioLoans) / 100
      this.formData.loanRate = Number(this.loanRate) / 100
      this.formData.floatingRange = Number(this.floatingRange) / 100

      this.$refs.form.validate()
  .then((result) => {
    console.log('验证通过', result)
    // 调用计算逻辑等
  })
  .catch((errors) => {
    console.log('验证未通过', errors)
  })

      getjsqlx(this.formData).then(res => {
        this.downData = res.data
        console.log(res)
        this.formData.money = res.data.money.toString()
        this.formData.totalLoan = res.data.totalLoan.toFixed(2).toString()
        this.formData.totalRepayments = res.data.totalRepayments.toFixed(2).toString()
        this.formData.totalInterest = res.data.totalInterest.toFixed(2).toString()
        this.formData.annualRepayment = res.data.annualRepayment.toFixed(2).toString()
        this.repayments = res.data.repayments
        this.jsgc = res.data.jsgc
      })
    },
    openVisible1() {
      this.visible1 = true
    },
    close1() {
      this.visible1 = false;
    },
    openVisible2() {
      this.visible2 = true
    },
    close2() {
      this.visible2 = false;
    },

  },
}
</script>

<style lang="less">
.jsqlx {
  background: #ffffff;
  width: 1168px;
  margin: 0 auto;
  border: 1px solid #e3e6ea;
  padding-bottom: 38px;


  

  .dialog1 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      width: 600px;
      // height: 200px;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;


      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        background: url('@/assets/dialog-background.png');

        padding: 0;

        .t-form__label {
          height: 32px;
          line-height: 32px;
          font-family: "Regular";
        }

        .custom-cascader-1 {
          width: 300px;
        }

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 15px;
        }

        .t-radio__label {
          height: 40px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;
          line-height: 40px;

          span {
            color: #000000;
          }
        }

        .complexity-table {
          padding: 20px;
          background: url('@/assets/dialog-background.png');
        }
      }
    }
  }

  .dialog2 {
    .t-dialog {
      width: 800px;

      .t-dialog__body {
        max-height: 600px;
        overflow: auto;
      }
    }

  }
}
</style>